// Modules
import React from "react";
import PropTypes from "prop-types";

// Assets
import { Skeleton } from "@material-ui/lab";

const GraphProgressbar = (props) => {
  const {
    className,
    data,
    loading,
  } = props;
  const {
    pourcentage_loyer_mensualite,
    mensualite,
    loyer,
    balance,
  } = data;

  return (
    <div className={`graph-progress-bar-container ${className}`}>
      {loading === true || pourcentage_loyer_mensualite === undefined || mensualite === undefined
        ? (
          <Skeleton
            variant="rect"
            width="100vh"
            height="20vh"
            className="skeleton"
          />
        ) : (
          <React.Fragment>
            <h5 className="title">Comparatif mensualité / loyer</h5>
            <div className="progress-bar">
              <div className="full-percent-bar">
                <div
                  className="percent-rent"
                  style={{ width: `${pourcentage_loyer_mensualite > 100 ? 100 : pourcentage_loyer_mensualite}%` }}
                >
                  {/* <p>Loyer : {loyer}€{pourcentage_loyer_mensualite < 100 ? `, soit ${Math.round(pourcentage_loyer_mensualite)}%` : ""}</p> */}
                </div>
                {pourcentage_loyer_mensualite < 100
                  ? (
                    <div
                      className="percent-leftover"
                      style={{ width: `${100 - pourcentage_loyer_mensualite}%` }}
                    >
                      <p>Reste à charge : {balance * -1}€, soit {Math.round(100 - pourcentage_loyer_mensualite)}%</p>
                    </div>
                  ) : null
                }
              </div>
              <div className="monthly-dues">
                <p className="legend">Mensualités : {mensualite}€</p>
                <span className="perpendicular-bar" />
              </div>
              {pourcentage_loyer_mensualite > 100
                ? (
                  <div
                    className="percent-extra"
                    style={{ width: `${pourcentage_loyer_mensualite - 100}%` }}
                  >
                    <p>Gain : {balance}€, soit +{Math.round(pourcentage_loyer_mensualite - 100)}%</p>
                  </div>
                ) : null}
            </div>
            <p className="legend">
              Loyer : {loyer}€, soit {Math.round(pourcentage_loyer_mensualite)}%
            </p>
            {/* <p className="legend">Mensualités : {mensualite}€</p> */}
          </React.Fragment>
        )}
    </div>
  );
};

GraphProgressbar.propTypes = {
  className: PropTypes.string,
  data: PropTypes.exact({
    pourcentage_loyer_mensualite: PropTypes.number,
    mensualite: PropTypes.number,
    loyer: PropTypes.number,
    balance: PropTypes.number,
  }).isRequired,
  loading: PropTypes.bool,
};

GraphProgressbar.defaultProps = {
  className: "",
  loading: false,
};

export default GraphProgressbar;
